import CityPageTemplate from "../city-template/CityPageTemplate";
import { duluthMnConfig } from "./data";

export default function DuluthPage() {
  return <CityPageTemplate config={duluthMnConfig} />;
}